import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {getUserTransactionDetails} from 'util/api';
import TransactionsData from './TransactionsData';
import {centsToString} from 'util/cashFormatter';
import ItemIcon from 'components/items/ItemIcon';
import UniversalProfileImage from 'components/universal/UniversalProfileImage';
import UniversalEmptyPageHeader from 'components/universal/UniversalEmptyPageHeader';

const TransactionDetails = () => {
    const {type} = useParams();
    const navigate = useNavigate();
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const transactionData = new TransactionsData(type, navigate);

    useEffect(() => {
        const fetchTransactionDetails = async () => {
            try {
                const data = await getUserTransactionDetails(type);
                const sortedData = data.sort((a, b) => new Date(b.time) - new Date(a.time));
                setTransactions(sortedData);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTransactionDetails();
    }, [type]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const formatTime = (timestamp) => {
        return new Date(timestamp).toLocaleString();
    };

    return (
        <div>
            <UniversalEmptyPageHeader text={'History'} image={'credit-card'} desktopText={true}/>
            {transactions.length > 0 ? (
                <table className="items-table">
                    <thead>
                    <tr>
                        {transactionData.header()}
                        <th>Time</th>
                        <th>Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    {transactions.map((transaction, index) => (
                        <tr
                            key={index}
                            onClick={() => transactionData.onClick(transaction)}
                            className="clickable-row"
                        >
                            {type === 'IMAGE' && (
                                <td>
                                    <UniversalProfileImage url={transaction.resourcePreview} beRoundy={false}/>
                                </td>
                            )}
                            {(type === 'ITEM_BUY' || type === 'ITEM_SELL') && (
                                <ItemIcon lootItem={transaction.resourcePreview} textSize={2}/>
                            )}
                            {type === 'CHAT_MESSAGE' &&
                                <td
                                    data-tooltip-id="main-tooltip"
                                    data-tooltip-content={transaction.resourcePreview}
                                >
                                    {transaction.resourcePreview.length > 10
                                        ? `${transaction.resourcePreview.substring(0, 8)}...`
                                        : transaction.resourcePreview}
                                </td>
                            }
                            <td>{formatTime(transaction.time)}</td>
                            <td style={{color: transaction.payAmount < 0 ? 'red' : 'green'}}>
                                {centsToString(Math.abs(transaction.payAmount))}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            ) : (
                <p>No details available for this transaction.</p>
            )}
        </div>
    );
};

export default TransactionDetails;
